export default __webpack_public_path__ + "static/media/EAST1020.34I-33748_-18355_0.cad4fe67.jpg";